import React from "react";
import { Parameter, RequestBody, SchemaType } from "../../../yaml-content";
import { MdCancel, MdCheckCircle } from "react-icons/md";

type Props = {
  parameters: Parameter[] | undefined;
  bodyParameter: RequestBody | undefined;
  componentSchemas: SchemaType[] | null;
};

const ParametersTable = ({
  parameters,
  bodyParameter,
  componentSchemas,
}: Props) => {
  function getParameterType(parameter: Parameter): string {
    if (parameter.schema && parameter.schema.type && parameter.schema.type) {
      return parameter.schema.type;
    }
    return "Undefined";
  }

  function findSchema(ref: string | null): SchemaType | null {
    const response = componentSchemas?.find((item) => item.path === ref);
    if (response) {
      return response;
    }
    return null;
  }

  return (
    <div className="sect5">
      {parameters && (
        <div>
          <div>
            <div className="relative">
              <div
                className="anchor absolute inset-0 -z-50 -top-[90px] bottom-[90px] lg:-top-[120px] lg:bottom-[120px]"
                id="_query_parameters_2"
              ></div>
              Parameters
            </div>
          </div>
          <table className="tablefixed dark:bg-medium-dark-grey table-auto p-0 frame-all grid-all stretch">
            <thead>
              <tr>
                <th className="tableblock halign-center valign-top w-1/6 lg:w-2/12 px-1">Name</th>
                <th className="tableblock halign-center valign-top w-1/6 lg:w-4/12 px-1">
                  Description
                </th>
                <th className="tableblock halign-center valign-top w-1/6 lg:w-1/12 px-1">
                  Required
                </th>
                <th className="tableblock halign-center valign-top w-1/6 lg:w-1/12 px-1">Type</th>
                <th className="tableblock halign-center valign-top w-1/6 lg:w-1/12 px-1">In</th>
                <th className="tableblock halign-center valign-top w-1/6 lg:w-3/12 px-1">Example</th>
              </tr>
            </thead>
            <tbody>
              {parameters &&
                parameters.map((parameter, index) => {
                  return (
                    <tr key={index}>
                      <td className="tableblock max-w-xl text-balance halign-left valign-middle">
                        <code>{parameter.name}</code>
                      </td>
                      <td className="tableblock max-w-xl text-balance halign-left valign-middle">
                        {parameter.description}
                      </td>
                      <td className="tableblock max-w-xl text-balance halign-left valign-middle">
                        {parameter.required && (
                          <MdCheckCircle
                            size={18}
                            className="w-full self-center text-primary-light"
                          />
                        )}
                        {!parameter.required && (
                          <MdCancel
                            size={18}
                            className="w-full self-center text-gray-400"
                          />
                        )}
                      </td>
                      <td className="tableblock max-w-xl text-balance halign-center valign-middle">
                        {getParameterType(parameter)}
                      </td>
                      <td className="tableblock max-w-xl text-balance halign-center valign-middle">
                        {parameter.in}
                      </td>
                      <td className="tableblock max-w-xl halign-center valign-middle">
                        <div>{parameter.example}</div>
                        {parameter.schema.enum &&
                          parameter.schema.enum.map((item, index) => {
                            return <div key={index}>{item}</div>;
                          })}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      )}
      {bodyParameter && (
        <div>
          <div>
            <div className="relative">
              <div
                className="anchor absolute inset-0 -z-50 -top-[90px] bottom-[90px] lg:-top-[120px] lg:bottom-[120px]"
                id="_query_parameters_2"
              ></div>
              Body Parameter
            </div>
          </div>
          <table className="tablefixed dark:bg-medium-dark-grey table-auto p-0 frame-all grid-all stretch">
            <thead>
              <tr>
                <th className="tableblock halign-center valign-top">Name</th>
                <th className="tableblock halign-center valign-top">
                  Description
                </th>
                <th className="tableblock halign-center valign-top">
                  Required
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tableblock halign-left valign-middle">
                  <code>
                    {
                      findSchema(
                        bodyParameter.content["application/json"].schema.$ref,
                      )?.name
                    }
                  </code>
                </td>
                <td className="tableblock halign-left valign-middle">
                  {bodyParameter.description + " "}
                  <a
                    href={`#_${findSchema(
                      bodyParameter.content["application/json"].schema.$ref,
                    )?.name}`}
                  >
                    <em>
                      {
                        findSchema(
                          bodyParameter.content["application/json"].schema.$ref,
                        )?.name
                      }
                    </em>
                  </a>
                </td>
                <td className="tableblock halign-left valign-middle">
                  <p className="tableblock">
                    {bodyParameter.required && (
                      <MdCheckCircle
                        size={18}
                        className="w-full self-center text-primary-light"
                      />
                    )}
                    {!bodyParameter.required && (
                      <MdCancel
                        size={18}
                        className="w-full self-center text-gray-400"
                      />
                    )}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
export default ParametersTable;
